__turbopack_context__.v({
  "content": "OhpmyW_content",
  "content-animation": "OhpmyW_content-animation",
  "item": "OhpmyW_item",
  "slide-down": "OhpmyW_slide-down",
  "slide-up": "OhpmyW_slide-up",
  "trigger": "OhpmyW_trigger",
});
